import Tastet from '../tastet.js';

var GOOGLE_MAP_API = 'AIzaSyBZFdN8Ij2wNxFBb7u44neeEaU_7uKJRwM';

export default class GoogleMap extends Tastet.Module {
  // init ------------------------------------------------------------------------------------------------------------
  init(callback, context) {
    var isRequested = window.googleMapRequested;
    var isLoaded = window.google && window.google.maps;
    var queue = window.googleMapQueue || (window.googleMapQueue = []);

    // the google maps already exists
    if (isLoaded) {
      return callback.apply(context);
    }

    // add the Map instance to the queue
    queue.push(callback);

    // Call the Google Map API once
    if (!isRequested) {
      let callback = this.utils.string.random('onGoogleMapsReady');
      var libraryUrl =
        '//maps.googleapis.com/maps/api/js?key=' + GOOGLE_MAP_API + '&libraries=geometry&callback=' + callback;
      window[callback] = function () {
        // go through the modules in queue and mark them as done
        var queue = window.googleMapQueue || [];
        for (var i = 0, l = queue.length; i < l; ++i) queue[i]();
        window.googleMapQueue = [];
      };
      this.utils.media.require(libraryUrl);
    }

    window.googleMapRequested = true;
  }
}
